<template>
	<div class="date-range">
		<span>Find patients between</span>
		&nbsp;
		<el-date-picker
			v-model="dateRange"
			type="daterange"
			format="MM/dd/yyyy"
			range-separator="and"
			start-placeholder="Start date"
			end-placeholder="End date"
			:picker-options="pickerOptions"
			:clearable="false"
			:default-time="['00:00:00', '23:59:59']">
		</el-date-picker>
		&nbsp;
		<el-button v-if="isDateRange" @click="change" size="small"
			type="primary">
			<strong style="font-size:14px">Apply</strong>
		</el-button>
		<el-button v-if="isDateRange" @click="clear" size="small">
			<strong style="font-size:14px">Clear</strong>
		</el-button>
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import eventId from '@/module/util/event-id'
import sameDay from '@/module/util/same-day'

const SHORTCUTS = ([
	{ text: 'Today', delay: 0 },
	{ text: 'Yesterday', delay: 1},
	{ text: 'Last 7 days', delay: 7},
	{ text: 'Last 30 days', delay: 30 }
]).map((shortcut) => ({
	text: shortcut.text,
	onClick: (picker) => {
		/**
		 * A date used to set time for start and end date
		 */
		let setterDateTime = new Date()
		// Setting hours for end of day to set end time
		setterDateTime.setHours(23, 59, 59)

		// Getting date of current day
		const setterDate = setterDateTime.getDate()

		// Setting end time as end of day today
		let end = new Date(setterDateTime)
		// In case of Yesterday end time set as end of day yesterday
		if(shortcut.text === 'Yesterday')
			end.setDate(setterDate - shortcut.delay)
		
		// Setting hours as start of day for choosing start time
		setterDateTime.setHours(0, 0, 0)

		// Subtracing days as per delay for the shortcut seletected
		setterDateTime.setDate(setterDate - shortcut.delay)

		// Setting start date as start of day with appropriate delay
		const start = new Date(setterDateTime)
		/**
		 * Emit for picking up date in date range picker
		 * @event
		 */
		picker.$emit('pick', [start, end])
	}
}))

export default {
	name: 'filter-viewer-date-range',

	props: {
		filter: {
			type: Object,
			required: true
		}
	},

	data() {
		var data = {
			/**
			 * Date range chosen by the filter
			 */
			dateRange: this.getfilterDateRange(this.filterArg),
			// Options for shortcuts
			pickerOptions: {
				shortcuts: SHORTCUTS
			}
		}

		return data
	},

	created() {
		this.dateRange = this.getfilterDateRange(this.filterArg)
	},

	computed: {
		...mapGetters('provider', [
			'getFilterArg'
		]),
		filterArg() {
			return this.getFilterArg(this.filter.id)
		},
		/**
		 * Calculates if date range is chosen or not
		 */
		isDateRange() {
			if(!this.dateRange)
				return false
			
			return (Array.isArray(this.dateRange) && this.dateRange.every((date) => date))
		}
	},

	methods: {
		...mapActions('provider', [
			'setFilterArg'
		]),
		clear() {
			this.dateRange = null
			this.change()
		},
		/**
		 * Change date range for the filter or clear it if not present
		 */
		change() {
			if(this.isDateRange)
				this.setFilterArg({
					id: this.filter.id,
					arg: {
						start: this.dateRange[0].getTime(),
						end: this.dateRange[1].getTime()
					}
				})
			else
				this.setFilterArg({
					id: this.filter.id,
					arg: {}
				})
		},
		/**
		 * Returns an array of filter date ranges for the range picker
		 * @param {{start: Number, end: Number}} filterArg 
		 */
		getfilterDateRange(filterArg) {
			return filterArg ? [new Date(filterArg.start), new Date(filterArg.end) ] : null
		}
	}
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>

<style lang="css" scoped>
.date-range .el-range-editor >>> .el-range-separator {
	font-size: 16px;
	color: #355170;
	font-weight: 700;
	width: 40px;
}
</style>
